import { render, staticRenderFns } from "./AdjuntoData.vue?vue&type=template&id=6fbada4d&"
import script from "./AdjuntoData.vue?vue&type=script&lang=js&"
export * from "./AdjuntoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports